module.exports = __webpack_public_path__ + "static/img/login.30edfcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login.png
// module id = Nl6a
// module chunks = 2